import React from 'react';
import Typography from 'new/elements/Typography';
import { Stack } from '@mui/material';
import { Button } from 'new/elements/Button';
import { AddRounded } from '@mui/icons-material';
import { Section } from 'new/components/settings/VendorBuilder/components/Section';
import {
  baseParameter,
  useVendorBuilder,
} from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { ResourceParameter } from 'new/components/settings/VendorBuilder/ResourceParameters/ResourceParameter';

interface ResourceParametersProps {
  endpointIndex: number;
}

export const ResourceParameters = (props: ResourceParametersProps) => {
  const { endpointIndex } = props;
  const { vendor, updateVendor } = useVendorBuilder();

  const onAddResourceParameter = () => {
    updateVendor((newVendor) => {
      const param = baseParameter(vendor);
      newVendor.endpoints[endpointIndex].parameters.push(param);
    });
  };

  return (
    <Section
      title={<div>Endpoint #{endpointIndex + 1}: ResourceParameters</div>}
      titleAcessory={
        <Typography variant="body2">
          Define parameters for this endpoint that will be filled by the user
        </Typography>
      }
      gap="16px"
    >
      {vendor?.endpoints[endpointIndex]?.parameters?.map((_, index) => {
        return <ResourceParameter key={index} endpointIndex={endpointIndex} index={index} />;
      })}
      <Stack alignItems="flex-start">
        <Button onClick={onAddResourceParameter} startIcon={<AddRounded />}>
          Add resource parameter
        </Button>
      </Stack>
    </Section>
  );
};
